/** The tabs of the order page, in display order. Each is also the last segment of its URL. */
export const ORDER_TABS = [
  "invoices",
  "products",
  "fulfillment",
  "amendments",
  "emails",
] as const;

export type OrderTab = (typeof ORDER_TABS)[number];

/** The tab a URL's last segment names, if it names one. */
export function orderTabFromUrlSegment(
  segment: string | undefined
): OrderTab | undefined {
  // Reservations and deliveries used to be tabs of their own.
  if (segment === "reservations" || segment === "deliveries") {
    return "fulfillment";
  }
  return ORDER_TABS.find((tab) => tab === segment);
}
